module.exports = ".image-preview{\r\n    height: 170px; \r\n    width: \"100%\"; \r\n    border: 2px solid #ccc; \r\n    display: -ms-flexbox; \r\n    display: flex; \r\n    -ms-flex-align: center; \r\n        align-items: center; \r\n    -ms-flex-pack: center; \r\n        justify-content: center;\r\n    background-color: #f0f0f0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/advertisement/add-new-advertisement/add-new-advertisement.component.css
// module id = 957
// module chunks = 1